import { ConfirmIconButton } from "./ConfirmIconButton";
import { getMaterialBaseName } from "../export/materialLabels";
import { LengthInput } from "../input/LengthInput";
import { ThicknessField } from "../input/ThicknessField";
import { useLocale } from "../i18n/useLocale.js";

export function RestStockCard({
  restStock,
  panelThicknesses,
  materialName,
  onAdd,
  onUpdate,
  onRemove,
}) {
  const { display } = useLocale();
  const materialBaseName = getMaterialBaseName(materialName);
  const dimensionUnit = display.unitSystem === "imperial"
    ? display.t("web.fields.unitIn")
    : display.t("web.fields.unitMm");

  return (
    <section className="rail-card rest-stock-card">
      <header className="rest-stock-header">
        <div className="card-kicker">{display.t("web.sections.materialStock")}</div>
        <div className="rest-stock-title-row">
          <h2>{display.t("web.sections.restStock")}</h2>
          <span className="material-kind-badge">{materialBaseName}</span>
        </div>
        <p className="rest-stock-intro">
          {restStock.length === 0
            ? display.t("web.restStock.introEmpty", { material: materialBaseName })
            : display.t("web.restStock.introWithItems")}
        </p>
      </header>

      {restStock.length > 0 && (
        <ul className="rest-stock-list">
          {restStock.map((item) => (
            <li key={item.id} className="rest-stock-item">
              <div className="rest-stock-item-head">
                <label className="rest-stock-field">
                  <span>{display.t("web.restStock.labelDescription")}</span>
                  <input
                    value={item.label}
                    placeholder={display.t("web.restStock.placeholderDescription")}
                    onChange={(event) => onUpdate(item.id, "label", event.target.value)}
                  />
                </label>
                <ConfirmIconButton
                  className="rest-stock-remove"
                  label={display.t("web.restStock.removeA11y")}
                  confirmLabel={display.t("web.restStock.removeConfirm", {
                    label: item.label || display.t("web.restStock.removeFallbackLabel"),
                  })}
                  onConfirm={() => onRemove(item.id)}
                >
                  ×
                </ConfirmIconButton>
              </div>
              <div className="dimension-pair">
                <label>
                  <span>{display.t("web.fields.length")}</span>
                  <div className="number-field compact">
                    <LengthInput
                      compact
                      className="table-input dimension-input"
                      valueMm={item.length}
                      onChangeMm={(value) => onUpdate(item.id, "length", value)}
                    />
                    <em>{dimensionUnit}</em>
                  </div>
                </label>
                <label>
                  <span>{display.t("web.fields.width")}</span>
                  <div className="number-field compact">
                    <LengthInput
                      compact
                      className="table-input dimension-input"
                      valueMm={item.width}
                      onChangeMm={(value) => onUpdate(item.id, "width", value)}
                    />
                    <em>{dimensionUnit}</em>
                  </div>
                </label>
              </div>
              <div className="dimension-pair">
                <label>
                  <span>{display.t("web.fields.thickness")}</span>
                  <ThicknessField
                    variant="table"
                    valueMm={item.thickness}
                    presets={panelThicknesses}
                    ariaLabel={display.t("web.fields.thickness")}
                    onChangeMm={(value) => onUpdate(item.id, "thickness", value)}
                  />
                </label>
                <label>
                  <span>{display.t("web.fields.quantity")}</span>
                  <input
                    type="number"
                    min="1"
                    value={item.quantity}
                    onChange={(event) => onUpdate(item.id, "quantity", event.target.value)}
                  />
                </label>
              </div>
            </li>
          ))}
        </ul>
      )}

      <button type="button" className="secondary-button rest-stock-add" onClick={onAdd}>
        {display.t("web.restStock.addButton")}
      </button>
    </section>
  );
}
